<template>
    <div class="col-12 mx-auto">
        <div class="card">
            <div class="card-header card-header bg-primary text-white h5 m-0">
                <page-title :title="($tc('administration.user.title',2))" icon="fas fa-users"></page-title>
            </div>
        </div>

        <kendo-tabstrip>
            <ul>
                <li v-if="hasEditRights" class="k-state-active">{{ $t('administration.userRoles.title') }}</li>
                <li v-if="hasEditRights">{{ $tc('administration.person.title', 2) }}</li>
                <li v-if="hasEditRights">{{ $t('administration.user.grid.title') }}</li>
                <li v-if="hasEditRights && showImportFromExcelButton">{{ $t('administration.import.title') }}</li>
            </ul>
            <div class="m-3" v-if="hasEditRights">
                <user-management></user-management>
            </div>
            <div class="mt-2" v-if="hasEditRights">
                <person-grid :showHeader="false"
                             :showPinButton="false">
                </person-grid>
            </div>
            <div v-if="hasEditRights">
                <user-grid></user-grid>
            </div>
            <div class="m-3" v-if="hasEditRights && showImportFromExcelButton">
                <div class="alert alert-info m-2" role="alert">
                    <ul class="ml-2">
                        <li>{{ $t('administration.import.fileHelperMessage') }}</li>
                    </ul>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>A: UserName</th>
                                <th>B: Email</th>
                                <th>C: Password</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="btn-group">
                    <button type="button"
                            class="btn btn-primary btn-lg"
                            v-if="showImportFromExcelButton && hasEditRights"
                            @click="selectImportFiles">
                        {{$t('buttons.importFromExcel.btnText')}}
                    </button>
                    <input type="file" id="importFile" class="selectFile" @change="goToImportFromExcel" />
                </div>
            </div>
        </kendo-tabstrip>

        <div>
            <div class="m-5"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import UserManagement from '@/components/administration/UserManagement.vue';
    import PersonGrid from '@/components/person/PersonGrid.vue';
    import UserGrid from '@/components/user/UserGrid.vue';
    import PageTitle from '@/components/common/PageTitle';
    import actionLogService from "@/services/actionLog.service"

    import { LayoutInstaller } from '@progress/kendo-layout-vue-wrapper';

    Vue.use(LayoutInstaller);

    export default {
        props: {
            showImportFromExcelButton: {
                default: true,
                type: Boolean
            }
        },
        components: {
            userManagement: UserManagement,
            PersonGrid,
            UserGrid,
            PageTitle
        },
        data() {
            return {};
        },
        methods: {
            selectImportFiles() {
                const dialog = $('#importFile');
                dialog.trigger('click');
            },
            goToImportFromExcel(args) {
                if (!this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                const $input = $('#importFile')[0];
                const files = $input.files;
                if (files && files.length > 0) {
                    const filename = files[0].name;
                    const file = files[0];

                    // clear the selected file so that the change event triggers when the same file is selected
                    $input.value = null;

                    const formData = new FormData();
                    formData.append('FileName', filename);
                    formData.append('FileContent', file);

                    this.$http
                        .post('/api/account/import', formData)
                        .then(response => {
                            actionLogService.usersImport(response.data.users);

                            this.$vs.notify({
                                title: response.request
                                    ? this.$t(
                                        'request.response.status.' +
                                        response.request.status
                                    )
                                    : this.$t('request.response.status.200'),
                                text: response.data.message
                                    ? response.data.message
                                    : response.request.statusText
                                        ? response.request.statusText
                                        : response.message,
                                color: 'success',
                                time: this.$store.getters.notificationDuration
                            });
                        })
                        .catch(error => {
                            this.$vs.notify({
                                title: this.$t(
                                    'request.response.status.' +
                                    this.$helpers.errorStatusCode(error)
                                ),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });
                        });
                }
            }
        },
        computed: {
            hasEditRights() {
                return this.$store.getters.claims.aspNetUser.read
                    || this.$store.getters.claims.aspNetUser.create
                    || this.$store.getters.claims.aspNetUser.update
                    || this.$store.getters.claims.aspNetUser.delete;
            },
        }
    };
</script>

<style scoped>
    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }
</style>
